import {
  BuildThumbnailRepresentationFunction,
  ThumbnailService,
} from "features/gallery/service/thumbnail.service"
import { GalleryService } from "features/gallery/service/gallery.service"
import { buildThumbnailRepresentation } from "features/gallery/service/thumbnail.functions"
import { mdiStar } from "@mdi/js"

export class PostThumbnailService extends ThumbnailService {
  constructor(galleryService: GalleryService) {
    super(galleryService, buildPostThumbnailRepresentation(galleryService))
  }
}

const buildPostThumbnailRepresentation =
  (galleryService: GalleryService): BuildThumbnailRepresentationFunction =>
  (thumbnailRepresentation, canEdit) => {
    const thumbnailRep = buildThumbnailRepresentation(galleryService)(
      thumbnailRepresentation,
      canEdit
    )
    if (thumbnailRep.isHighlight.value && !galleryService.canEdit.value) {
      thumbnailRep.topLeftAction.value = {
        ...thumbnailRep.topLeftAction.value,
        showAlways: true,
        icon: mdiStar,
        tooltip: "Dieses Bild ist ein Highlight!",
      }
    }
    return thumbnailRep
  }
